export const FETCH_PROJECT_DETAILS = "FETCH_PROJECT_DETAILS"
export const FETCH_PROJECT_DETAILS_SUCCESS = 'FETCH_PROJECT_DETAILS_SUCCESS';
export const FETCH_PROJECT_DETAILS_FAILURE = 'FETCH_PROJECT_DETAILS_FAILURE';
export const TAG_STATUS = 'TAG_STATUS';
export const TAG_STATUS_DETAILS_SUCCESS = 'TAG_STATUS_DETAILS_SUCCESS';
export const TAG_STATUS_DETAILS_FAILURE = 'TAG_STATUS_DETAILS_FAILURE';
export const CREATE_PROJECT = 'CREATE_PROJECT';
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS';
export const CREATE_PROJECT_FAILURE = 'CREATE_PROJECT_FAILURE';
export const SET_COUNTRIES = 'SET_COUNTRIES';  